import User from "./User";

export default class BookingSlot {
  id: number;
  type: string;
  start: Date;
  duration: string;
  user: User | null = null;  
  consultant: User | null = null;
  price: number;
  notes: string | null = null;
  addToCalendarUrl: string | null = null;
  meetingLink: string | null = null;
  canBeRescheduled: boolean;
  canBeCancelled: boolean;
  rescheduleTimes: number;
  reschedulesLeft: number;
  address: string | null = null;
  onsiteVisitRequestId: number | null = null;
  consultantFirstName: string;
  consultantLastName: string;
  consultantMobile: string;

  constructor({
    id,
    type,
    start,
    duration,
    user,
    consultant,
    price,
    notes,
    add_to_calendar_url,
    meet_link,
    can_be_rescheduled,
    can_be_cancelled,
    reschedule_times,
    reschedules_left,
    address,
    onsite_visit_request_id,
    consultant_first_name,
    consultant_last_name,
    consultant_mobile,
  }: {
    id: number;
    type: string;
    start: Date;
    duration: string;
    user: any | null;
    consultant: any | null;
    price: number;
    notes: string | null;
    add_to_calendar_url: string | null;
    meet_link: string | null;
    can_be_rescheduled: boolean;
    can_be_cancelled: boolean;
    reschedule_times: number;
    reschedules_left: number;
    address: string | null;
    onsite_visit_request_id: number | null;
    consultant_first_name: string;
    consultant_last_name: string;
    consultant_mobile: string;
  }) {
    this.id = id;
    this.type = type;
    this.start = new Date(start);
    this.duration = duration;
    this.user = user && new User(user);
    this.consultant = consultant && new User(consultant);
    this.price = price;
    this.notes = notes;
    this.addToCalendarUrl = add_to_calendar_url;
    this.meetingLink = meet_link;
    this.canBeRescheduled = can_be_rescheduled;
    this.canBeCancelled = can_be_cancelled;
    this.rescheduleTimes = reschedule_times;
    this.reschedulesLeft = reschedules_left;
    this.address = address;
    this.onsiteVisitRequestId = onsite_visit_request_id;
    this.consultantFirstName = consultant_first_name;
    this.consultantLastName = consultant_last_name;
    this.consultantMobile = consultant_mobile;
  }
}


